// extracted by mini-css-extract-plugin
export default {"title":"CFVbtPVVwaGSrp7AWgK9","buttonsContainer":"CgILscFRCCyJ5eU_O2_3"};